export const INCLUDED_INVOICE_TYPE_IDS: number[] = [1, 2, 3, 4];
export const DELIVERY_NOTE_TYPE_ID = 5;

// Nota: Rellena INCLUDED_INVOICE_TYPE_IDS con los IDs de tipos de factura
// (excluyendo albaranes). Si está vacío, no se aplicará filtro por tipo.